export const BankDetailTabs = {
	BankProfile: 'Bank Profile',
	Addresses: 'Addresses',
	CheckConfig: 'Check Configuration',
	CashAccounts: 'Cash Account Associations',
	Sites: 'Sites',
	BankReconSetup: 'Bank Recon Setup',
	PositivePaySetup: 'Positive Pay Setup',
};
